var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-download",
    "data-name": "Icon awesome-download",
    d: "M4.219,0H5.781A.468.468,0,0,1,6.25.469V3.75H7.963a.39.39,0,0,1,.275.666L5.268,7.389a.378.378,0,0,1-.533,0L1.76,4.416a.39.39,0,0,1,.275-.666H3.75V.469A.468.468,0,0,1,4.219,0ZM10,7.344V9.531A.468.468,0,0,1,9.531,10H.469A.468.468,0,0,1,0,9.531V7.344a.468.468,0,0,1,.469-.469H3.334l.957.957a1,1,0,0,0,1.418,0l.957-.957H9.531A.468.468,0,0,1,10,7.344ZM7.578,9.063a.391.391,0,1,0-.391.391A.392.392,0,0,0,7.578,9.063Zm1.25,0a.391.391,0,1,0-.391.391A.392.392,0,0,0,8.828,9.063Z",
    fill: "#185cff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDownload);
export default __webpack_public_path__ + "static/media/report-download.858af38bda4f4db64f96f6ad9e068667.svg";
export { ForwardRef as ReactComponent };